import React, { useState, useContext, useRef } from 'react'
import {AppContext} from '../context/AppContext'
import styled from 'styled-components'
import { useHistory } from 'react-router'
import { NavLink } from 'react-router-dom'
import useClickOutside from '../hooks/useClickOutside'

export default function CourseNavigation() {
  const [selectedUnit, setSelectedUnit] = useState(null)
  const [isNavOpen, setIsNavOpen] = useState(false)
  const {appState} = useContext(AppContext)
  const history = useHistory()
  const navRef = useRef(null)
  useClickOutside(navRef, () => setIsNavOpen(false))

  const goToLesson = (e, unit, lesson) => {
    e.preventDefault()
    if(!appState.isLessonsLocked || lesson.status !== false) {
      history.push(`/courses/${appState.course.slug}/${unit.key}/${lesson.slug}`)
    }
  }

  return (
    <CourseNavigationWrapper className="course-navigation-wrapper" open={isNavOpen} ref={navRef}>
      <NavLink exact to={`/courses/${appState.course.slug}`}>Course Overview</NavLink>
      <ul className={`units ${appState.isLessonsLocked && 'lessons-locked'}`}>
        {appState.course.units.map((unit) => {
          return (
            <UnitItem key={unit.key} className='unit'>
              <UnitHeader className='unit-title' onClick={() => setSelectedUnit(unit.key)}>{unit.unit_name}</UnitHeader>
              {selectedUnit === unit.key && (
                <LessonItems className='unit-lessons'>
                  {unit.lessons.map((lesson) => {
                    return (
                      <LessonItem status={lesson.status} key={lesson.slug} className='lesson'>
                        <LessonStatusIcon className="lesson-status-icon">
                          {appState.isLessonsLocked && lesson.status === false && <i className="fas fa-lock"></i>}
                          {lesson.status === 'COMPLETED' && <i className="fas fa-check"></i>}
                        </LessonStatusIcon>
                        {!appState.isLessonsLocked || lesson.status !== false ? (
                          <CourseNavigationLink onClick={e => goToLesson(e, unit, lesson)}>{lesson.title}</CourseNavigationLink>
                        ) : (<LessonLockedLink>{lesson.title}</LessonLockedLink>)}
                      </LessonItem>
                    )
                  })}
                </LessonItems>
              )}
            </UnitItem>
          )
        })}
      </ul>
      <CourseNavigationTab onClick={() => setIsNavOpen(!isNavOpen)}>Course Navigation</CourseNavigationTab>
    </CourseNavigationWrapper>
  )
}

const CourseNavigationWrapper = styled.div`
  background: ${({theme}) => theme.background };
  color: ${({theme}) => theme.text};
  position: fixed;
  top: 25%;
  left: 100%;
  transform: translateX(${({open}) => open ? '-100%' : '0'});
  padding: 1rem;
  z-index: 1000;
  transition: 0.3s ease-out;
  outline: solid 1px var(--dark);
  outline-offset: -1px;
  min-width: 10rem;
  min-height: 14rem;

  a {
    color: ${({theme}) => theme.text};
    font-size: 0.7rem;
    display: block;
    line-height: 1.1;
    margin-bottom: 1rem;
    text-transform: uppercase;
    font-weight: bold;
    transition: 0.3s ease-out;

    &:hover {
      color: var(--primary)
    }
  }

  ul {
    list-style: none;
    margin: 0;
  }
`

const UnitItem = styled.li`
  margin-bottom: 0.5rem;
  padding: 0 0.3rem;
`

const CourseNavigationTab = styled.div`
  background: var(--primary);
  color: ${({theme}) => theme.text};
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(90deg);
  transform-origin: top left;
  padding: 0.5rem;
  font-size: 0.7rem;
  white-space: nowrap;
  line-height: 1;
  cursor: pointer;
`

const UnitHeader = styled.div`
  font-size: 0.8rem;
  text-transform: uppercase;
  cursor: pointer;
  border-bottom: solid 1px ${({theme}) => theme.text};
`

const LessonItem = styled.li`
  color: ${({status, theme}) => status === 'STARTED' ? 'var(--primary)' : theme.text};
  font-size: 0.75rem;
  position: relative;
`

const LessonItems = styled.ul`
  padding: 0.25rem 0.5rem 0 1.25rem;
`

const CourseNavigationLink = styled.div`
  cursor: pointer;
  transition: 0.3s ease-out;

  &:hover {
    color: var(--primary);
  }
`

const LessonLockedLink = styled.div`
  font-style: italic;
  opacity: 0.5;
`

const LessonStatusIcon = styled.div`
  position: absolute;
  top: 0rem;
  left: -0.25rem;
  transform: translateX(-100%);
  font-size: 0.8rem;
  opacity: 0.8;
`